<template>
  <optional-field :enabled.sync="enabled" :name="field.name">
    <v-select :label="label"
              :items="fieldItems"
              item-text="label"
              item-value="value"
              :append-outer-icon="!field.required ? 'block' : ''"
              @click:append-outer="disable"
              v-model="localData"></v-select>
  </optional-field>
</template>

<script>
import Field from '../../../mixins/JsonEditorField'
import OptionalField from './OptionalField'

export default {
  name: 'JsonSelect',
  components: { OptionalField },
  mixins: [Field],
  computed: {
    /**
     * The items that will appear in the select field
     * We prepend a "random" option if the default value is null
     *
     * @returns {*[]}
     */
    fieldItems () {
      return this.field.default === null
        ? [{ label: 'random', value: null }, ...this.field.items]
        : this.field.items
    }
  }
}
</script>
